var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout-wrapper"}},[_c('NavBar'),_c('SideBar'),_c('div',{staticClass:"main-content"},[_c('router-view',{ref:"view"}),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }